<nav class="sidebar">
  <div
    class="sidebar-body"
    (mouseenter)="operSidebarFolded()"
    (mouseleave)="closeSidebarFolded()"
    >
    <!--- Toggler -->
    <div class="d-flex pt-3 px-2 align-items-center">
      <ideapa-icon-button
        class="toggler"
        cssClasses="text-dark"
        (clicked)="toggleSidebar($event)"
        #sidebarToggler
        icon="menu_open"
        >
      </ideapa-icon-button>
      <div class="mx-3">
        <input
          type="text"
          class="form-control menu-entry-search"
          placeholder="Cerca..."
          [formControl]="formControl"
          />
      </div>
      <!-- <div
      class="sidebar-toggler not-active"
      #sidebarToggler
      (click)="toggleSidebar($event)"
      >
      <span></span>
      <span></span>
      <span></span>
    </div> -->
  </div>
  <!--- Sidemenu start -->

  <ul class="sidebar-nav" id="sidebar-menu" #sidebarMenu>
    @for (item of menuItems; track item) {
      @if (
        item.modulo === undefined ||
        item.modulo === (modulo$ | ngrxPush)?.codice
        ) {
        <li
          class="nav-item"
          [class.nav-category]="item.isTitle"
          [routerLinkActive]="['active']"
          *ngxPermissionsOnly="checkHierarchyPermissions(item)"
          >
          <!-- <span class="active-bar"></span> -->
          @if (hasItems(item)) {
            <button
                (click)="
                  item.expanded !== undefined
                    ? (item.expanded = !item.expanded)
                    : (item.expanded = false)
                "
              class="tree-node"
                [class.collapsed]="
                  item.expanded !== undefined ? !item.expanded : false
                "
                [class.selected-module]="
                  item.modulo === (modulo$ | ngrxPush)?.codice
                "
              >
              <div
                class="module-highlight"
                [style.backgroundColor]="(modulo$ | ngrxPush)?.colore"
              ></div>
              <span class="z-index-1"> {{ item.label }}</span>
              <span class="material-symbols-outlined expander">
                expand_less
              </span>
            </button>
            <ul
                [ngbCollapse]="
                  item.expanded !== undefined ? !item.expanded : false
                "
              >
              @for (subitem of item.subItems; track subitem) {
                <ng-container>
                  <ng-container
                      *ngTemplateOutlet="
                        itemTemplate;
                        context: { item: subitem, level: 1 }
                      "
                    >
                  </ng-container>
                </ng-container>
              }
            </ul>
          }
          @if (!hasItems(item) && item.link) {
            <ng-container
              *ngTemplateOutlet="itemTemplate; context: { item: item }"
              >
            </ng-container>
          }
          <ng-template #itemTemplate let-item="item" let-level="level">
            <ng-container>
              <li
                class="nav-item"
                [ngClass]="{ 'side-nav-item': hasItems(item) }"
                [style.paddingLeft]="level * 0.5 + 'rem'"
                *ngxPermissionsOnly="checkHierarchyPermissions(item)"
                >
                @if (!hasItems(item) && item.link) {
                  <a
                    class="nav-link nav-link-ref"
                    [title]="item.label"
                    [routerLink]="item.link"
                    [class.opened]="isTabOpened(item.link || '') | ngrxPush"
                    [routerLinkActive]="['active']"
                    [routerLinkActiveOptions]="{ exact: false }"
                    >
                    <span class="link-title"> {{ item.label }}</span>
                  </a>
                }
                @if (hasItems(item)) {
                  <button
                      (click)="
                        item.expanded !== undefined
                          ? (item.expanded = !item.expanded)
                          : (item.expanded = false)
                      "
                    class="tree-node"
                      [class.collapsed]="
                        item.expanded !== undefined ? !item.expanded : false
                      "
                    >
                    <span class="z-index-1"> {{ item.label }}</span>
                    <span class="material-symbols-outlined expander">
                      expand_less
                    </span>
                  </button>
                  <ul
                    class="mt-1"
                      [ngbCollapse]="
                        item.expanded !== undefined ? !item.expanded : false
                      "
                    >
                    @for (subitem of item.subItems; track subitem) {
                      <ng-container
                          *ngTemplateOutlet="
                            itemTemplate;
                            context: { item: subitem, level: level + 1 }
                          "
                        >
                      </ng-container>
                      <!-- <ng-template
                      #itemTemplate
                      let-item="subitem"
                    ></ng-template> -->
                  }
                </ul>
              }
            </li></ng-container
            >
            <!-- <a
            class="nav-link nav-link-ref"
            [title]="item.label"
            [routerLink]="item.link"
            [class.opened]="isTabOpened(item.link || '') | ngrxPush"
            [routerLinkActive]="['active']"
            [routerLinkActiveOptions]="{ exact: false }"
            >
            <span class="link-title"> {{ item.label }}</span>
          </a> -->
        </ng-template>
        <!-- @if (hasItems(item)) {
   <ul
          class="sidebar-nav sub-menu nav-second-level"
          aria-expanded="false"
          >
          @for (subitem of item.subItems; track subitem) {
            <li
              class="nav-item"
              [ngClass]="{ 'side-nav-item': hasItems(subitem) }"
            >
              @if (hasItems(subitem)) {
                <a
                  class="nav-link side-nav-link-a-ref"
                  href="javascript:void(0);"
                >
                  @if (subitem.icon) {
                    <i
                      class="link-icon"
                      [attr.data-feather]="subitem.icon"
                      appFeatherIcon
                    ></i>
                  }
                  <span class="link-title"> {{ subitem.label }}</span>
                  <span
                    class="link-arrow"
                    data-feather="chevron-down"
                    appFeatherIcon
                  ></span>
                </a>
              }
              @if (!hasItems(subitem)) {
                <a
                  class="nav-link nav-link-ref"
                  [routerLink]="subitem.link"
                  [routerLinkActive]="['active', 'mm-active']"
                  [routerLinkActiveOptions]="{ exact: false }"
                  [attr.data-parent]="subitem.parentId"
                >
                  @if (subitem.icon) {
                    <i
                      class="link-icon"
                      [attr.data-feather]="subitem.icon"
                      appFeatherIcon
                    ></i>
                  }
                  {{ subitem.label }}
                </a>
              }
            </li>
          }
        </ul> 
 }-->
    </li>
  }
}
<!-- <li class="nav-item nav-category">Docs</li>
<li class="nav-item">
  <a
    href="https://www.nobleui.com/angular/documentation/docs.html"
    target="_blank"
    class="nav-link"
    >
    <i class="link-icon" data-feather="hash" appFeatherIcon></i>
    <span class="link-title">Documentation</span>
  </a>
</li> -->
</ul>

<ideapa-footer></ideapa-footer>
<!--- Sidemenu end -->
</div>
</nav>
